// jQuery on window, in a module of its own so that it is evaluated before
// rails-ujs (see scripts/globals.js): rails-ujs installs its jQuery bridge --
// which is what adds the CSRF token to `$.ajax` requests, used by the
// file_uploader behaviour -- only when window.jQuery exists as it initializes.
import __jQuery__ from 'jquery'

Object.assign(window, {
  $: __jQuery__,
  jQuery: __jQuery__
})
